import { render, staticRenderFns } from "./LexonKanbanColumnTemplate.vue?vue&type=template&id=0fa17e75&scoped=true&lang=pug"
import script from "./LexonKanbanColumnTemplate.vue?vue&type=script&lang=ts"
export * from "./LexonKanbanColumnTemplate.vue?vue&type=script&lang=ts"
import style0 from "./LexonKanbanColumnTemplate.vue?vue&type=style&index=0&id=0fa17e75&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa17e75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fa17e75')) {
      api.createRecord('0fa17e75', component.options)
    } else {
      api.reload('0fa17e75', component.options)
    }
    module.hot.accept("./LexonKanbanColumnTemplate.vue?vue&type=template&id=0fa17e75&scoped=true&lang=pug", function () {
      api.rerender('0fa17e75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LexonKanban/templates/LexonKanbanColumnTemplate.vue"
export default component.exports